/** @format */
import * as yup from "yup";

const passwordRules = /\S/g

export const passwordResetSchema = yup.object().shape({
  password: yup
    .string()
    .min(4)
    .matches(passwordRules, {
      message: "Password must not contain Whitespaces.",
    })
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), undefined], "Password Don't Match")
    .required(),
});
